import { SITE_METADATA } from './site-metadata'

export const HEADER_NAV_LINKS = [
  { href: '/projects', title: 'Projects', emoji: 'sparkles' },
  { href: '/blog', title: 'Blog', emoji: 'writing-hand' },
  { href: '/snippets', title: 'Snippets', emoji: 'dna' },
  { href: '/about', title: 'About', emoji: 'billed-cap' },
  { href: '/tags', title: 'Tags', emoji: 'label' },
  { href: '/valentine', title: 'Valentine', emoji: 'red-heart' },
]

export const FOOTER_NAV_LINKS = [
  { href: '/projects', title: 'Projects' },
  { href: '/blog', title: 'Blog' },
  { href: '/snippets', title: 'Snippets' },
  { href: '/about', title: 'About' },
  { href: '/tags', title: 'Tags' },
  { href: '/feed.xml', title: 'RSS Feed' },
]

export const FOOTER_PERSONAL_STUFF = [
  { href: '/about', title: 'About' },
  // { href: SITE_METADATA.resumeUrl, title: 'Resume' },
  { href: 'https://github.com/skymore', title: 'GitHub' },
  { href: 'https://www.linkedin.com/in/ruit/', title: 'LinkedIn' },
  { href: 'https://www.youtube.com/@realruitao', title: 'YouTube' },
  { href: 'mailto:realruitao@gmail.com', title: 'Email' },
]
